import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import BatchFormulasServiceName, {BatchFormulasService} from "../../services/batches/batchFormulas.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NewGuidServiceName, {NewGuidService} from "../../services/utility/newguid.service";
import {apsCommands} from "../../shared/dto/aps.commands";
import {apsCommon} from "../../shared/dto/aps.common";
import template from './editBatchFormulaUsage.tpl.html';

let requires = [BatchFormulasServiceName, NotifyServiceName, LoaderServiceName, NewGuidServiceName];

interface EditBatchFormulaUsageController {
  batchFormulas: apsViewModels.BatchFormulaItem[];
  mode: string;
  isNew: boolean;
  submit(): void;
  cancel(): void;
}

export interface EditBatchFormulaUsageParams {
  plant: Plant;
  tank: apsCommon.IdAndName;
  batchFormulas: apsViewModels.BatchFormulaItem[];
  instance?: apsViewModels.BatchFormulaUsageItem;
}

export function openEditBatchFormulaUsage(data: EditBatchFormulaUsageParams,
                                 $modal: mm.foundation.modal): angular.IPromise<apsViewModels.BatchFormulaUsageItem> {
  return $modal.open({
    template: template,
    controller: 'EditBatchFormulaUsageCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

class EditBatchFormulaUsageCtrl implements EditBatchFormulaUsageController {
  instance: apsViewModels.BatchFormulaUsageItem;
  batchFormulas: apsViewModels.BatchFormulaItem[];
  form: angular.IFormController;
  mode: string;
  isNew: boolean;

  private batchFormulasService: BatchFormulasService;
  private $modalInstance: mm.foundation.modalInstance;
  private notifyService: NotifyService;
  private loaderService: LoaderService;
  private newGuidService: NewGuidService;

  constructor(
    data: EditBatchFormulaUsageParams,
    newGuidService: NewGuidService,
    batchFormulasService: BatchFormulasService,
    $modalInstance: mm.foundation.modalInstance,
    notifyService: NotifyService,
    loaderService: LoaderService
  ) {
    this.batchFormulasService = batchFormulasService;
    this.$modalInstance = $modalInstance;
    this.notifyService = notifyService;
    this.loaderService = loaderService;
    this.newGuidService = newGuidService;
    if (data.instance) {
      this.mode = 'Update';
      this.isNew = false;
      this.instance = {...data.instance};
    } else {
      this.mode = 'Add';
      this.isNew = true;
      this.instance = <apsViewModels.BatchFormulaUsageItem>{
        plantId: data.plant.id,
        plantName: data.plant.name,
        tankId: data.tank.id,
        tankName: data.tank.name,
        usageDate: moment().startOf('day').toDate()
      };

      this.newGuidService.getNewGuid('BatchFormulaUsage').then(id => this.instance.id = id);
    }
    this.batchFormulas = data.batchFormulas;
  }

  submit(): void {
    if (this.form.$invalid) {
      return;
    }

    var commandPromise: angular.IPromise<any>;
    if (this.isNew) {
      let command = <apsCommands.AddBatchFormulaUsage>this.instance;
      commandPromise = this.batchFormulasService.addUsage(command);
    } else {
      let command = <apsCommands.UpdateBatchFormulaUsage>this.instance;
      commandPromise = this.batchFormulasService.updateUsage(command);
    }

    this.loaderService.loadingPromise(commandPromise
      .then(() => {
        this.instance.batchFormulaSequence = _.find(this.batchFormulas,
           {id: this.instance.batchFormulaId}).formulaSequence;
        this.$modalInstance.close(this.instance);
      }, this.notifyService.handleApiErrors)
    );
  }

  cancel(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.editBatchFormulaUsage', requires)
  .controller('EditBatchFormulaUsageCtrl', EditBatchFormulaUsageCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/batches/editBatchFormulaUsage.controller.ts